module.exports = "/_next/static/images/peerlist-72cc12df95d77e7f9452c3abeff4a4c7.png";